export function pickGenderText({ male, female, other }, gender = "other") {
  const g = String(gender || "other").toLowerCase();
  if (g === "male") return male || other || female || "";
  if (g === "female") return female || other || male || "";
  return other || male || female || "";
}
